export default __webpack_public_path__ + "static/media/railway-museum.79ac666e.jpg";